import {DatePicker} from 'antd';
import autobind from 'autobind-decorator';
import {Moment} from 'moment';
import React from 'react';
import {withTranslation, WithTranslation} from 'react-i18next';


export type DateRangeValue  = {
    startDate: Moment | null;
    endDate: Moment | null;
}

export type DateRangeProps =  {
    value?: DateRangeValue;
    onChange?: (value: DateRangeValue) => void;
}

export interface DateRangeState {
    endOpen: boolean,
}

export const checkDates = (t: (text: string) => string) => (_: any, value: DateRangeValue) => {
    if (value.endDate !== null && value.startDate !== null)
        return Promise.resolve();
    return Promise.reject(new Error(t('Initial and final date must be specified')));
}

class DateRange extends React.Component<DateRangeProps & WithTranslation, DateRangeState> {
    constructor(props: DateRangeProps & WithTranslation) {
        super(props);
        this.state = {
            endOpen: false,
        }
    }

    @autobind
    disabledStartDate(startValue: Moment | null) {
        const endValue = this.props.value?.endDate;
        if (!startValue || !endValue) {
            return false;
        }
        return startValue.valueOf() > endValue.valueOf();
    };

    @autobind
    disabledEndDate(endValue: Moment | null) {
        const startValue = this.props.value?.startDate;
        if (!endValue || !startValue) {
            return false;
        }
        return endValue.valueOf() <= startValue.valueOf();
    };

    @autobind
    onStartChange(value: Moment | null) {
        if (this.props?.onChange)
            this.props?.onChange({ startDate: value, endDate: this.props.value?.endDate ?? null });
    };

    @autobind
    onEndChange(value: Moment | null) {
        if (this.props?.onChange)
            this.props?.onChange({ startDate: this.props.value?.startDate ?? null, endDate: value });
    };

    @autobind
    handleStartOpenChange(open: boolean) {
        if (!open) {
            this.setState({ endOpen: true });
        }
    };
    @autobind
    handleEndOpenChange(open: boolean) {
        this.setState({ endOpen: open });
    };

    render() {
        const { endOpen } = this.state;
        const { t } = this.props;
        const startValue = this.props?.value?.startDate;
        const endValue = this.props?.value?.endDate;
        return (
            <div>
                <DatePicker
                    disabledDate={this.disabledStartDate}
                    format="DD-MM-YYYY"
                    value={startValue}
                    placeholder={t("Start")}
                    onChange={this.onStartChange}
                    onOpenChange={this.handleStartOpenChange}
                    style={{ marginRight: 8 }}
                />
                <DatePicker
                    disabledDate={this.disabledEndDate}
                    format="DD-MM-YYYY"
                    value={endValue}
                    placeholder={t("End")}
                    onChange={this.onEndChange}
                    open={endOpen}
                    onOpenChange={this.handleEndOpenChange}
                />
            </div>
        );
    }
}

export default withTranslation()(DateRange) as any as React.ComponentClass<DateRangeProps, DateRangeState>;